import styled from 'styled-components';

import PageTitle from '../components/pageTitle';

import jarmarkImage from '../images/jarmark.jpg';
import drogaImage from '../images/droga_krzyzowa.jpg';
import rekolekcjeImage from '../images/rekolekcje.jpg';
import kobietyImage from '../images/kobiety.jpg';
import mezczyzniImage from '../images/mezczyzni.jpg';
import goryImage from '../images/gory.jpg';
import biblijneImage from '../images/biblijne.jpg';
import sobotnieImage from '../images/sobotnie.jpg';
import blueWave from '../images/blue_wave.png';

const ActivityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 60px 40px;

  @media (max-width: 800px) {
    gap: 40px;
  }
`;

const ActivityCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  font-size: 16px;
  line-height: 1.5;

  @media (max-width: 800px) {
    max-width: 590px;
    width: 96%;
    margin: 0 auto;
  }
`;

const ActivityCardTitle = styled.p`
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 8px;
`;

const ActivityPhoto = styled.img`
  border-radius: 16px;
  margin-bottom: 16px;
  pointer-events: none;
`;

const TitleWave = styled.img`
  width: 300px;
  pointer-events: none;

  @media (max-width: 800px) {
    width: 250px;
  }
`;

const activities = [
  {
    title: 'Spotkania sobotnie',
    photo: sobotnieImage,
    description:
      'Co dwa tygodnie w sobotę gromadzimy się całą wspólnotą w klasztorze. Nasze dzieci zostają wraz z opiekunkami w pobliskich salkach, zaś my wysłuchujemy konferencji naszych Duszpasterzy i omawiamy je w małych grupach. Dzielimy się tym, jak rozumiemy Słowo i jaki ma wpływ na nasze codzienne życie. Spotkanie kończymy wspólną Mszą Świętą lub Adoracją, a po nich nieoficjalny punkt programu - pogaduchy.',
  },
  {
    title: 'Spotkania biblijne',
    photo: biblijneImage,
    description:
      'Na tych spotkaniach czytamy, rozważamy i omawiamy wybrane fragmenty Pisma Świętego pod okiem naszych Duszpasterzy. Jest na czas na wyjaśnienie tego, co niezrozumiałe i postawienie ważnych pytań. Do udziału nie jest wymagany doktorat z teologii fundamentalnej i nie trzeba być znawcą Biblii. Można tylko słuchać, można pytać lub podzielić się tym, co zrodziło w nas Słowo. W wolności i wzajemnym szacunku.',
  },
  {
    title: 'Spotkania kobiet',
    photo: kobietyImage,
    description:
      'To miejsce dla kobiet, które potrzebują chwili wytchnienia. Jest okazją do integracji, rozmowy, wymiany doświadczeń i złapania oddechu. W luźnej atmosferze w salce DROPSa lub „na mieście” spotkamy się, żeby pogadać o tematach innych niż te, którymi żyjemy na co dzień. Organizujemy też wspólne wietrzenie szaf, zamawiamy pizzę albo umawiamy się na film.',
  },
  {
    title: 'Spotkania mężczyzn',
    photo: mezczyzniImage,
    description:
      'To nieformalne spotkania mężczyzn, okazja by się spotkać, poznać, zżyć i budować zaufanie. Organizujemy ciekawy czas i wyszukujemy różne atrakcje. Laserowy paintball, gokarty, szermierka, escape room, trampoliny – ty tylko niektóre z miejsc, jakie odwiedziliśmy. Najczęściej towarzyszą nam też nasi Duszpasterze. Na koniec siadamy, żeby coś zjeść i porozmawiać o tym, co dla nas ważne. W luźnej atmosferze, bez stresu. Tak, jak faceci czasem potrzebują pogadać.',
  },
  {
    title: 'Wyjazdy rekolekcyjne',
    photo: rekolekcjeImage,
    description:
      'Dwa razy do roku – w Wielkim Poście i w Adwencie – wyjeżdżamy całą wspólnotą na weekendowe rekolekcje prowadzone przez naszych Duszpasterzy. Towarzyszą nam również dzieci, dla których zapewniona jest troskliwa opieka. W ciągu dnia trwamy na modlitwie, rozważamy Słowo Boże i rozmawiamy o nim, starając się usłyszeć, dokąd prowadzi nas Pan. Wieczorami natomiast odkładamy powagę na bok – wyciągamy przekąski, siadamy przy planszówkach i rozmawiamy do późnej nocy, ciesząc się byciem razem.',
  },
  {
    title: 'Wyjazd wakacyjny',
    photo: goryImage,
    description:
      'Raz w roku wyjeżdżamy na cały tydzień w polskie góry, by złapać oddech i pobyć razem w spokojniejszym rytmie. Każdy spędza ten czas tak, jak najbardziej lubi: jedni zdobywają górskie szczyty, inni wybierają spacery, spokojnie wypitą kawę i odpoczynek z dala od codzienności. Dzieci w tym czasie tworzą własne małe przyjaźnie, a my, dorośli, również mamy okazję do rozmów, spotkań i zacieśniania więzi. W tym wyjeździe chodzi przede wszystkim o odpoczynek, budowanie relacji i cieszenie się wspólnym czasem w pięknym otoczeniu.',
  },
  {
    title: 'Jarmark Św. Dominika',
    photo: jarmarkImage,
    description:
      'Raz w roku na Służewie odbywa się Jarmark św. Dominika — wydarzenie, w które z radością się angażujemy. Przygotowujemy własne stoisko, a wcześniej wspólnymi siłami gotujemy zupę pomidorową, robimy hot dogi oraz pieczemy słodkości. Podczas jarmarku sprzedajemy je, łącząc dobrą zabawę z działaniem na rzecz wspólnoty. To dla nas czas współpracy, śmiechu i budowania jedności przy bardzo praktycznych zadaniach.',
  },
  {
    title: 'Droga krzyżowa',
    photo: drogaImage,
    description:
      'Co roku w Wielkim Poście mężczyźni z naszej wspólnoty, pod duchowym kierownictwem Duszpasterzy, przygotowują Męską Drogę Krzyżową. Przygotowują rozważania, a następnie czytają je podczas nabożeństwa, przeżywając razem tajemnicę Męki Pańskiej. To wyjątkowa forma posługi i ważny sposób uczestniczenia w życiu wspólnoty parafialnej.',
  },
];

export default function Activities() {
  return (
    <>
      <PageTitle>
        Nasze inicjatywy
        <TitleWave src={blueWave} />
      </PageTitle>
      <ActivityGrid>
        {activities.map((activity) => (
          <ActivityCard key={activity.title}>
            <ActivityPhoto src={activity.photo} alt={activity.title} />
            <ActivityCardTitle>{activity.title}</ActivityCardTitle>
            {activity.description}
          </ActivityCard>
        ))}
      </ActivityGrid>
    </>
  );
}
